<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-treeTable #tt [value]="tareasTree" [columns]="cols"
                         selectionMode="checkbox" [(selection)]="tareasTreeNodos"
                         [rowHover]="true" 
                         rows="{{appConfig.ux.treeTableRows}}"
                         paginator="{{appConfig.ux.treeTablePaginator}}" 
                        rowsPerPageOptions="{{appConfig.ux.treeTableRowsPerPageOptions}}" 
                         [scrollable]="false" [responsive]='true'
                         [filterDelay]="0" [globalFilterFields]="['nombre', 'descripcion']"
                         sortMode="multiple" [multiSortMeta]="multiSortMeta"
                         styleClass="p-treetable-striped p-treetable-sm">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start table-header">
                            <button pButton type="button" 
                                    label="{{appConfig.ux.actions.create}}" 
                                    icon="pi pi-plus"
                                    (click)="nuevaTarea();"
                                    [disabled]="!puedeEjecutar('crear')">
                            </button>
                            <button pButton pRipple type="button"
                                    pTooltip="Borrar seleccionadas" tooltipPosition="bottom"
                                    icon="pi pi-trash" class="p-button-help p-ml-1"
                                    (click)="confirmarBorrarSeleccionados();" 
                                    [disabled]="!puedeEjecutar('borrado') 
                                    || !(tareasTreeNodos && tareasTreeNodos.length)">
                            </button>
                        </div>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="tt.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."/>
                        </span>
                    </div>
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start p-mt-2 table-header">
                        <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                        <span style="margin-left: .25em; vertical-align: middle">Seleccionar todo</span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [ttSortableColumn]="col.field"  [hidden]="!col.visible">
                            {{col.header}}<p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
                    </th>
                    <th style="width: 12rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns; let i = index" [hidden]="!col.visible">
                    <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                    <p-treeTableCheckbox [value]="rowNode" *ngIf="i == 0"></p-treeTableCheckbox>
                    {{rowData[col.field]}}
                    </td>
                    <td style="width: 12rem">
                        <button pButton pRipple type="button"
                                pTooltip="{{appConfig.ux.actions.add}}" tooltipPosition="bottom" 
                                icon="pi pi-plus" class="p-button-rounded" 
                                (click)="agregarTarea(rowData);"
                                [disabled]="!puedeEjecutar('crear')">
                        </button>
                        <button pButton pRipple type="button" 
                                pTooltip="{{appConfig.ux.actions.edit}}" tooltipPosition="bottom" 
                                icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                                (click)="editarTarea(rowData);"
                                [disabled]="!puedeEjecutar('escritura')">
                        </button>
                        <button pButton type="button" 
                                pTooltip="{{appConfig.ux.actions.delete}}" tooltipPosition="bottom" 
                                icon="pi pi-trash" class="p-button-rounded p-button-text p-button-secondary"
                                (click)="confirmarBorrarTarea(rowNode);"
                                [disabled]="!puedeEjecutar('borrado')">
                        </button>
                    </td> 
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr><td [attr.colspan]="columns.length">{{appConfig.ux.emptyMsg}}</td></tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton type="button" 
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-text"
                            (click)="tt.reset();">
                    </button>
                </ng-template>
            </p-treeTable>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!-- Diálogos de creación/edición de tarea -->
<p-dialog [header]="(tarea && tarea.id) ? 'Editar Tarea' : 'Nueva Tarea'" 
          [(visible)]="mostrarEditor && tarea" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
          (onHide)="mostrarEditor=false;">
    <form #tareaEditorForm="ngForm" 
          (ngSubmit)="guardarTarea();"
          [ngClass]="{'disabledForm': false}"><!--tareaEditorForm.reset();-->
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12">
                <h2 class="p-text-uppercase">{{tarea.name}}</h2>
            </div>
            <div class="p-field col-12">
                <label for="grupo">Grupo</label>
                <p-autoComplete inputId="grupo" name="grupo"   
                                [(ngModel)]="grupo" 
                                [suggestions]="tareasFiltrados" 
                                (completeMethod)="filtrarTareas($event)" field="nombre"
                                placeholder="Buscar por nombre..."
                                [showEmptyMessage]="true" emptyMessage="{{appConfig.ux.emptyMsg}}"
                                [minLength]="3" [dropdown]="true" 
                                [forceSelection]="true">
                </p-autoComplete>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="codigo">Código</label>
                <input #codigo="ngModel" id="codigo" name="codigo" type="text" 
                       [(ngModel)]="tarea.code"
                       [disabled]="(tarea && tarea.id)"
                       [pattern]="appConfig['validationRegExp']['codigoPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['codigoPattern']" 
                           *ngIf="tareaEditorForm.controls['codigo']
                           && !tareaEditorForm.controls['codigo'].valid 
                           && (tareaEditorForm.controls['codigo'].dirty 
                           || tareaEditorForm.controls['codigo'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Nombre</label>
                <input #nombre="ngModel" id="nombre" name="nombre" type="text" 
                       [(ngModel)]="tarea.name" 
                       [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                           *ngIf="tareaEditorForm.controls['nombre']
                           && !tareaEditorForm.controls['nombre'].valid 
                           && (tareaEditorForm.controls['nombre'].dirty 
                           || tareaEditorForm.controls['nombre'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="icono">Icono</label>
                <p-dropdown id="icono" name="icono" 
                            [options]="iconos" optionLabel="name"
                            [(ngModel)]="selectedIcon"
                            placeholder="Buscar un icono por nombre."
                            emptyMessage="La lista de iconos está vacía."
                            [showClear]="true" filter="true" filterBy="name" autoDisplayFirst="true"
                            emptyFilterMessage="{{appConfig.ux.emptyMsg}}"
                            [showTransitionOptions]="'.18s'" [hideTransitionOptions]="'.3s'"
                            required="false">
                    <ng-template pTemplate="selectedItem">
                        <div class="country-item" *ngIf="selectedIcon">
                            <i [class]="'pi pi-fw pi-' + selectedIcon.code.toLowerCase()"></i> 
                            {{selectedIcon.name}}
                        </div>
                    </ng-template>
                    <ng-template let-icono pTemplate="item">
                        <div class="country-item">
                            <i [class]="'pi pi-fw pi-' + icono.code.toLowerCase()"></i> 
                            {{icono.name}}
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="ruta">Ruta de navegación</label>
                <input #ruta="ngModel" id="ruta" name="ruta" type="text" 
                       [(ngModel)]="tarea.routerLink"
                       [disabled]="(tarea && tarea.id)"
                       [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                           *ngIf="tareaEditorForm.controls['ruta']
                           && !tareaEditorForm.controls['ruta'].valid 
                           && (tareaEditorForm.controls['ruta'].dirty 
                           || tareaEditorForm.controls['ruta'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="orden">Orden</label>
                <p-inputNumber #orden="ngModel" inputId="orden" name="orden"
                               [(ngModel)]="tarea.orden"
                               [min]="0" [step]="1"
                               [showButtons]="true" inputStyleClass="p-inputnumber-input"
                               decrementButtonIcon="pi pi-minus" decrementButtonClass="p-inputnumber-button-down p-button-secondary"
                               incrementButtonIcon="pi pi-plus" incrementButtonClass="p-inputnumber-button-up p-button-primary"
                               required>
                </p-inputNumber>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="asignable">¿Se puede asignar al usuario?</label>
                <p-selectButton id="asignable" name="asignable"
                                [options]="opciones" 
                                [(ngModel)]="tarea.asignable" optionLabel="name" optionValue="value"
                                required>
                </p-selectButton>
            </div>
            <div class="p-field col-12">
                <label for="descripcion">Características de la tarea</label>
                <textarea #descripcion="ngModel" id="descripcion" name="descripcion" type="text"
                          [(ngModel)]="tarea.description" 
                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                          [rows]="5"
                          pInputTextarea></textarea>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                           *ngIf="tareaEditorForm.controls['descripcion'] 
                           && !tareaEditorForm.controls['descripcion'].valid 
                           && (tareaEditorForm.controls['descripcion'].dirty 
                           || tareaEditorForm.controls['descripcion'].touched)">
                </p-message>
            </div>
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="mostrarEditor=false;">
                </button>
                <button pButton type="submit" 
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        [disabled]="(!tareaEditorForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton type="button" 
                label="No"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton type="button" 
                label="Sí"
                icon="pi pi-check" class="p-ml-2"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>